module.exports = __webpack_public_path__ + "static/img/hr_visitor_card06.756cf5fe.png";